import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpEvent, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { globalConfig } from '../utils/globalConfig';
import { MenuService } from 'src/app/modules/layout/services/menu.service';
import { AuthService } from 'src/app/modules/auth/auth.service';
import { PUBLIC_COMUNICADOS_REQUEST } from './http-interceptor.interceptor';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  constructor(private router: Router, private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const menuService = inject(MenuService);
    return next.handle(req).pipe(
      catchError((e: HttpErrorResponse) => {
        if (e.status === 401 && !req.context.get(PUBLIC_COMUNICADOS_REQUEST)) {
          if (sessionStorage.getItem(globalConfig.tokenApi)) {
            this.authService.toastMessage = 'Su sesión ha expirado, por favor ingrese a la plataforma nuevamente.';
          }
          sessionStorage.removeItem(globalConfig.tokenApi);
          menuService.modalDetalleTransaccionVisible = false;
          if (req.headers.has('skip-Interceptor')) {
            this.router.navigate(['/auth/sign-in'], { queryParams: { error: req.headers.get('skip-Interceptor') } });
          } else {
            this.router.navigate(['/auth/sign-in']);
          }
        }
        return throwError(() => e);
      }),
    );
  }
}
